import { buildInventoryForm, inventorySubmit } from "./helper";

jQuery(function ($) {

  const url = "https://accesspass.io";
  const apiToken = "eyJpdiI6ImtrTm0xTSsrTHBkdk5yMEJmcndSWHc9PSIsInZhbHVlIjoiWTJQS3ZRVDI3ai9RQ0RkUUZScEIzVE90V2VRbGFuWjh6dTVqYzRvSjVXRT0iLCJtYWMiOiI0MTM0MWYyMDZiNTMxZmE2YjZhMzgyNGMzOTdiZjkzOWE2OGI3YzIzOGZiMjA2OWE5YjIxYTNmNTMxODFkNWU4IiwidGFnIjoiIn0=";
  const userToken = localStorage.getItem("login-token");

  if (document.getElementById("user-profile")) {
    const user = localStorage.getItem("user-response");

    if (user) {
      const userObject = JSON.parse(user);
      //prefill user edit page

      prefillUserEditPage(userObject);

      // console.log(userObject.first_name);

      $("#welcome-name").text("Welkom " + userObject.first_name);
      $(".loader").addClass("active");

      // console.log("user events list API ready");

      const settings = {
        url: url + "/api/event/subscribed/all",
        method: "GET",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userToken}`, // Add a space after "Bearer"
          "Api-Token":
            apiToken,
        },
        error: function (error) {
          console.log("error", error);
        },
      };

      $.ajax(settings).done(function (response) {
        console.log("response", response);

        const divUser = $("#event-user-api");
        divUser.empty();

        //if the user did not sub to any events
        if (response.result.data.length === 0) {
          divUser.html('<div class="text-lg">geen evenementen gevonden</div>');
          $(".loader").removeClass("active");
        }

        //if user subbed to event
        if (response.result.data.length > 0) {
          response.result.data.forEach((item) => {
            $("#subscribed-event").addClass(`subscribed-event-${item.id}`);

            const divBtn = $("#event-user-btn");
            divBtn.empty();
            const button = $("<button>", {
              class:
                "event-user-btn viewticket-trigger gap-3 align-bottom pil-btn-black w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative flex items-center justify-center cursor-pointer hover:bg-white hover:text-black hover:border-black dark:hover:bg-black dark:hover:text-white dark:hover:border-white",
              "data-id": item.id,
              "data-info": JSON.stringify(item),

              html: '<span class="mr-2 text-lg font-degularText pb-1">bekijk ticket</span>',
            });
            divBtn.append(button);

            const divinventoryBtn = $("#event-user-inventory");
            divinventoryBtn.empty();
            const inventoryBtn = $("<div>", {
              class:
                "event-user-inventory text-lg font-degularText underline underline-offset-4 text-center pb-4 cursor-pointer hover:opacity-70",
              "data-inventories": JSON.stringify(item.inventories),
              "data-id": item.id,
              "data-title": item.title,
              html: "aanvullende informatie",
            });
            divinventoryBtn.append(inventoryBtn);

            const divmeerBtn = $("#event-user-meerbtn");
            divmeerBtn.empty();
            const meerbutton = $("<div>", {
              class:
                "event-user-meerbtn text-lg font-degularText underline underline-offset-4 text-center pb-4 cursor-pointer hover:opacity-70",
              "data-id": item.id,
              html: "meer informatie",
            });
            divmeerBtn.append(meerbutton);

            const divAfmeldenBtn = $("#afmelden");
            divAfmeldenBtn.empty();
            const afmeldenBtn = $("<div>", {
              class:
                "cancel-ticket-trigger text-lg font-degularText underline underline-offset-4 text-center pb-4 cursor-pointer hover:opacity-70",
              "data-id": item.id,
              "data-uuid": item.uuid,
              "data-info": JSON.stringify(item),
              html: "afmelden",
            });
            divAfmeldenBtn.append(afmeldenBtn);


            const divDownloadAsPdf = $("#download-as-pdf");
            divDownloadAsPdf.empty();
            const downloadPdf = $("<div>", {
              class: "download-pdf text-lg font-degularText underline underline-offset-4 text-center pb-4 cursor-pointer hover:opacity-70",
              "data-info": JSON.stringify(item),
              html: "download als pdf",
            });
            divDownloadAsPdf.html(downloadPdf);

            //image
            if (item.image != null) {
              const eventImageHero = $("#event-user-image");
              eventImageHero.attr("src", item.image);
            }

            //title
            if (item.title != null) {
              $("#event-user-title").text(item.title);
            }

            //date NU
            if (item.start_date != item.end_date) {
              $("#event-user-date").html(
                "Van " +
                item.start_date +
                " t/m " +
                item.end_date +
                " <br> " +
                item.time +
                " uur"
              );
            } else if (item.start_date == item.end_date) {
              $("#event-user-date").html(
                item.start_date + " <br> " + item.time + " uur"
              );
            }

            //location
            if (item.location) {
              $("#event-user-location").html(item.location);
            }

            const eventUserHtml =
              document.getElementById("event-user").innerHTML;
              divUser.append(eventUserHtml);
            $(".loader").removeClass("active");
          });
        }
      });

      //view tix btn
      $(document).on("click", ".event-user-btn", function () {
        idBTN = $(this).data("id");
        console.log(idBTN);

        console.log($(this).data("info"));
        //get the data and put it to the modal
        const item = $(this).data("info");
        $("#viewTicketImage").html(
          '<img src="' + item.image + '"  class="rounded object-cover"/>'
        );
        $("#viewTicketTitle").html(item.title);

        if (item.start_date != item.end_date) {
          $("#viewUserDate").html(
            "Van " +
            item.start_date +
            " t/m " +
            item.end_date +
            " <br> " +
            item.time +
            " uur"
          );
        } else if (item.start_date == item.end_date) {
          $("#viewUserDate").html(
            item.start_date + " <br> " + item.time + " uur"
          );
        }

        if (item.name) {
          $("#viewTicketName").html(item.name);
        }

        if (item.ticket_number) {
          $("#viewTicketNumber").html(item.ticket_number);
        }

        if (item.organisation) {
          $("#viewTicketOrganisation").html(
            '<div class="flex justify-between"><div>Organisatie</div><div>' +
            item.organisation +
            "</div>"
          );
        }

        if (item.location) {
          $("#viewEventLocation").html(item.location);
        }

        if (item.qr_code) {
          $("#viewQR").html('<img src="' + item.qr_code + '">');
        }

        showDialogViewTicket();
      });

      //view more btn
      $(document).on("click", ".event-user-meerbtn", function () {
        idBTN = $(this).data("id");
        window.location.href = `/agenda-detail?eventID=${idBTN}`;
      });

      $(document).on("click", ".event-user-inventory", function() {
        const inventories = $(this).data('inventories');
        const id = $(this).data('id');
        const title = $(this).data('title');
        buildInventoryForm(inventories, title, id );
        inventorySubmit();

        const modalInventory = document.querySelectorAll(".modal-inventory");

          modalInventory.forEach((modal) => {
            modal.classList.add("show-modal-news");
            // modal.classList.remove("invisible");
            // modal.classList.remove("opacity-0");
          });
      })

      $(document).on("click", ".cancel-ticket-trigger", function () {
        const eventId = $(this).data("uuid");
        const item = $(this).data('info');

        console.log('x', eventId);

        $("#cancelViewTicketImage").html(
          '<img src="' + item.image + '"  class="rounded object-cover"/>'
        );
        $("#cancelViewTicketTitle").html(item.title);
        $('#cancel-ticket').html('<button id="cancel-ticket2" class="gap-3 align-bottom w-full md:w-auto mt-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black" data-uuid="' + eventId + '"><span class="pb-1 text-lg">Ja</span></button>');

        showDialogCancelTicket();
        $('.event-cancel-action').show();
      });


      $(document).on("click", "#cancel-ticket2", function () {
        const eventId = $(this).data('uuid');
        console.log('cancelling for real');
        $('.loader').addClass('active');
        $('.loader-bg').removeClass('invisible');

        const cancelTicketApi = {
          url: url + "/api/event/cancel",
          method: "POST",
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${userToken}`, // Add a space after "Bearer"
            "Api-Token":
              apiToken,
          },
          data: JSON.stringify({ "uuid": eventId }),
          error: function (error) {
            console.log("error", error);
          },
        };


        $.ajax(cancelTicketApi).done(function (response) {
          const {event_id} = response.result;

          $('.loader').removeClass('active');
          $('.loader-bg').addClass('invisible');
          $('.event-cancel-action').hide();
          $('.image-title').html('<div class="text-black text-center text-[23px]"> Evenement afgemeld</div>')

          //remove html
          $(`.subscribed-event-${event_id}`).remove();

          //remove from sessionStorage
          const registeredEventJSON = sessionStorage.getItem('registeredEvent');
          let registeredEventArray = [];
          if (registeredEventJSON) {
            try {
              registeredEventArray = JSON.parse(registeredEventJSON);
            } catch (error) {
              console.error('Error parsing JSON data:', error);
            }
          }
          const idToRemove = event_id;
          const updatedEventArray = registeredEventArray.filter(id => id !== idToRemove);
          const updatedEventJSON = JSON.stringify(updatedEventArray);
          sessionStorage.setItem('registeredEvent', updatedEventJSON);


        })
      })
    }
  }
  //js

  //view ticket
  const modalViewTicket = $("#modal-viewticket");
  const triggersViewTicket = document.querySelectorAll(".viewticket-trigger");
  const closeButtonViewTicket = document.querySelector(
    ".close-viewticket-button"
  );

  function showDialogViewTicket() {
    console.log("show view ticket");
    modalViewTicket.addClass("show-modal-news");
    document.body.style.overflow = "hidden";
  }

  function closeDialogViewTicket() {
    modalViewTicket.removeClass("show-modal-news");
    document.body.style.overflow = "auto";
  }

  function toggleModalViewTicket() {
    modalViewTicket.toggleClass("show-modal-news");
    if (modalViewTicket.hasClass("show-modal-news")) {
      closeDialog();
      showDialogViewTicket();
    } else {
      closeDialogViewTicket();
    }
  }

  function windowOnClickViewTicket(event) {
    if (event.target === modalViewTicket) {
      toggleModalViewTicket();
    }
  }

  for (let i = 0; i < triggersViewTicket.length; i++) {
    triggersViewTicket[i].addEventListener("click", toggleModalViewTicket);
  }

  closeButtonViewTicket.addEventListener("click", toggleModalViewTicket);
  window.addEventListener("click", windowOnClickViewTicket);

  // confirm cancel ticket


  const modalCancelTicket = $("#modal-cancelTicket");

  function showDialogCancelTicket() {
    console.log("show cancel ticket");
    modalCancelTicket.addClass("show-modal-news");
    document.body.style.overflow = "hidden";
  }

  function closeDialogCancelTicket() {
    modalCancelTicket.removeClass("show-modal-news");
    document.body.style.overflow = "auto";
  }

  function toggleModalCancelTicket() {
    console.log("closing");
    modalCancelTicket.toggleClass("show-modal-news");
    if (modalCancelTicket.hasClass("show-modal-news")) {
      closeDialog();
      showDialogCancelTicket();
    } else {
      closeDialogCancelTicket();
    }
  }

  function windowOnClickCancelTicket(event) {
    if (event.target === modalCancelTicket) {
      toggleModalCancelTicket();
    }
  }

  $(".close-cancelTicket-button").click(function () {
    toggleModalCancelTicket();
  });
  window.addEventListener("click", windowOnClickCancelTicket);

  //download pdf
  $(document).on("click", ".download-pdf", function () {

    const loader = $(this).parent().siblings(".loader");
    loader.addClass("active");
    console.log('xxx', loader)
    const info = $(this).data("info");

    $.ajax({
      url: '/session/token',
      method: 'GET',
      success: function (sessionToken) {
        // Now you have the session token
        // You can use it in your AJAX requests or other interactions
        // console.log('Session Token:', sessionToken);

        $.ajax({
          url: `/api/pdf/generate`,
          method: "POST",
          cache: false,
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": sessionToken
          },
          data: JSON.stringify(info),
          xhr: function () {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
              if (xhr.readyState == 2) {
                if (xhr.status == 200) {
                  xhr.responseType = "blob";
                } else {
                  xhr.responseType = "text";
                }
              }
            };
            return xhr;
          },
          success: function (data) {
            //Convert the Byte Data to BLOB object.
            var blob = new Blob([data], { type: "application/octetstream" });

            //Check the Browser type and download the File.
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);

            var a = $("<a />");
            a.attr("download", "evenmenten.pdf");
            a.attr("href", link);
            $("body").append(a);
            a[0].click();
            $("body").remove(a);

            loader.removeClass("active");
          },
        });
      }
    });
  });



  /**
   * Prefill user edit form
   */
  function prefillUserEditPage(user) {
    // console.log('xxx', user)
    $('#editFirstName').val(user.first_name);
    $('#editLastName').val(user.last_name);
    $('#editEmail').val(user.email);
    if (user.organisation) {
      $('#editOrganisation').val(user.organisation);
    }
    if (user.dealder) {
      $('#editDealer').val(user.dealer);
    }
  }

  //useredit
  $('#userEditForm').submit(function (e) {

    e.preventDefault();
    const formData = $(this).serializeArray();
    const jsonData = {};

    $.each(formData, function (index, field) {
      jsonData[field.name] = field.value;
    });

    var settings = {
      "url": `${url}/api/user/update`,
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Accept": "application/json",
        "Api-Token": `${apiToken}`,
        "Content-Type": "application/json",
        "Authorization": `Bearer ${userToken}`,
      },
      "data": JSON.stringify(jsonData),
      complete: function () {
        // Re-enable form fields after AJAX is complete
        $('#userEditForm :input').prop('disabled', false);
      },
      error: function (error) {
        // console.log()
        $('.loader').removeClass('active');
        const errorResponse = JSON.parse(error.responseText);
        // console.log({errorResponse})
        const errors = errorResponse.errors;
        for (const field in errors) {
          if (errors.hasOwnProperty(field)) {
            const errorMessages = errors[field];
            let message = '';
            console.log(`${field}:`);
            errorMessages.forEach(errorMessage => {
              console.log(`- ${errorMessage}`);
              message += errorMessage;
            });
            $(`#error_edituser_${field}`).html(message);
          }
        }
      }
    };

    $.ajax(settings).done(function (response) {
      console.log(response);

      if (response.success) {
        console.log('yey')
        // $('#forgot_password').hide();
        // $('.reset-success').show();
      } else {
        // $('#error_email').html(response.message);
        // $('.loader').removeClass('active');
      }
    });

    $('.loader').removeClass('active');
  });



  const modalResetPassword = $("#modal-resetPassword");

  function showDialogResetPassword() {
    // console.log("show cancel ticket");
    modalResetPassword.addClass("show-modal-news");
    document.body.style.overflow = "hidden";
  }

  function closeDialogResetPassword() {
    modalResetPassword.removeClass("show-modal-news");
    document.body.style.overflow = "auto";
  }

  function toggleModalResetPassword() {
    // console.log("closing");
    modalResetPassword.toggleClass("show-modal-news");
    if (modalResetPassword.hasClass("show-modal-news")) {
      // closeDialog();
      showDialogResetPassword();
    } else {
      closeDialogResetPassword();
    }
  }

  function windowOnClickResetPassword(event) {
    if (event.target === modalResetPassword) {
      toggleModalResetPassword();
    }
  }

  $(".close-resetPassword-button").click(function () {
    toggleModalResetPassword();
  });
  window.addEventListener("click", windowOnClickResetPassword);

  $(document).on("click", ".password-reset-toggle", function () {
    toggleModalResetPassword();
  });

  // reset password
  $('#resetPassword').submit(function (e) {
    e.preventDefault();
    $('#loader-reset-password').addClass('active');

    const formData = $(this).serializeArray();
    const jsonData = {};

    $.each(formData, function (index, field) {
      jsonData[field.name] = field.value;
    });

    const settings = {
      url: url + "/api/user/changePassword",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userToken}`, // Add a space after "Bearer"
        "Api-Token": apiToken,
      },
      data: JSON.stringify(jsonData),
      error: function (error) {
        console.log("error", error);
      },
    };


    $.ajax(settings).done(function (response) {
      console.log("response", response);
      $('#loader-reset-password').removeClass('active');
      $('.reset-successful').html('<div class="text-black mb-5">Wachtwoord bijgewerkt</div>');
      $('#resetPassword input').val('');
    })
  })
});
